import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import $, { param } from "jquery";
import { Row, Col, Spinner, Dropdown } from "react-bootstrap";

import PsContext from "../../../context/PsContext";
import API from "../../../utils/API";
import { upperCase } from "../../../utils";
import { toast } from "react-hot-toast";
import FeaturedProduct from "../../elements/Products/Featured";
import ProductLoader from "../Home/productLoader";
import NO_PRODUCT_IMG from "../../../assets/img/empty.webp";
import FilterSidebar from "./catFilter";

const NewCategoryView = (props) => {
  const context = useContext(PsContext);
  const [initialLoader, setInitialLoader] = useState(true);
  const [filterLoader, setFilterLoader] = useState(false);
  const [products, setProducts] = useState([]);
  const [startIndex] = useState(1);
  const [limit] = useState(50);
  const [allProducts, setAllProducts] = useState([]);
  const [filters, setFilters] = useState({});
  const [activeClass, setActiveClass] = useState("normal");
  const [showFilter, setShowFilter] = useState(false);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [queryParams, setQueryParams] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const slug = props.match.params.name;

  const [filterCounts, setFilterCounts] = useState({
    color: {},
    size: {},
    offerOnly: 0,
  });

  const handleSortChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      sortBy: value,
    }));
  };

  const handleFilterChange = (type, value) => {
    let formattedValue;
    if (type === "minPrice" || type === "maxPrice") {
      formattedValue = parseFloat(value || 0).toFixed(2);
    } else {
      formattedValue = value;
    }
    setFilters((prev) => ({
      ...prev,
      [type]: formattedValue,
    }));
  };

  useEffect(() => {
    //const search = props.location.search?.replace("?", "") || "";
    const search = props.location.search
      ? props.location.search.replace("?", "")
      : "";
    setQueryParams(search);
  }, [props.location.search]);

  useEffect(() => {
    const curProducts = [...allProducts];
    const counts = {
      color: {},
      size: {},
      offerOnly: 0,
    };

    allProducts.forEach((item) => {
      if (item.color) {
        item.color.split(",").forEach((color) => {
          const key = color.trim().toLowerCase();
          if (key) counts.color[key] = (counts.color[key] || 0) + 1;
        });
      }
      if (item.i_size) {
        const sizeStr = item.i_size.toUpperCase().replace(/\s/g, "");
        counts.size[sizeStr] = (counts.size[sizeStr] || 0) + 1;
      }
      if (parseFloat(item.salesdiscount) > 0) {
        counts.offerOnly++;
      }
    });

    setFilterCounts(counts);

    let filtered = curProducts;
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== "" && value.length !== 0) {
        if (key === "minPrice") {
          filtered = filtered.filter(
            (item) => parseFloat(item.salesrate) > value
          );
        } else if (key === "maxPrice") {
          filtered = filtered.filter(
            (item) => parseFloat(item.salesrate) < value
          );
        } else if (key === "color" && Array.isArray(value)) {
          filtered = filtered.filter((item) =>
            value.some(
              (color) =>
                item.color &&
                item.color.toLowerCase().includes(color.toLowerCase())
            )
          );
        } else if (key === "size" && Array.isArray(value)) {
          filtered = filtered.filter((item) =>
            value.some((size) => {
              const [minSize, maxSize] = size.split("-").map(Number);
              if (!item.i_size) return false;
              if (item.i_size.includes("TO")) {
                const [start, end] = item.i_size
                  .split("TO")
                  .map((s) => parseInt(s.trim()));
                return start <= maxSize && end >= minSize;
              } else {
                const val = parseInt(item.i_size.trim());
                return val >= minSize && val <= maxSize;
              }
            })
          );
        } else if (key === "offerOnly" && value === true) {
          filtered = filtered.filter(
            (item) => parseFloat(item.salesdiscount) > 0
          );
        }
      }
    });

    if (filters.sortBy) {
      const sortFn = {
        "a-z": (a, b) => (a.itemname || "").localeCompare(b.itemname || ""),
        "z-a": (a, b) => (b.itemname || "").localeCompare(a.itemname || ""),
        "price-low-high": (a, b) =>
          parseFloat(a.salesrate) - parseFloat(b.salesrate),
        "price-high-low": (a, b) =>
          parseFloat(b.salesrate) - parseFloat(a.salesrate),
        "date-old-new": (a, b) => new Date(a.idate) - new Date(b.idate),
        "date-new-old": (a, b) => new Date(b.idate) - new Date(a.idate),
      }[filters.sortBy];
      if (sortFn) filtered.sort(sortFn);
    }

    setProducts(filtered);
  }, [filters, allProducts]);

  useEffect(() => {
    const handleScroll = () => {
      setActiveClass(window.scrollY === 0 ? "normal" : "top");
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const loadProducts = async (page = 1, isInitialLoad = false) => {
    if (isInitialLoad) {
      setInitialLoader(true);
      setCurrentPage(1);
    } else {
      setFilterLoader(true);
    }

    try {
      const startFrom = (page - 1) * limit + 1;
      let url = `v1/site/item/category/${slug}/${startFrom}/${limit}`;
      if (queryParams) url += "?" + queryParams;

      const res = await API.get(url);

      if (res.data.status === "1") {
        setAllProducts(res.data.data);
        setCurrentPage(page);

        if (res.data.totalCount) {
          setTotalPages(Math.ceil(res.data.totalCount / limit));
        } else {
          setTotalPages(res.data.data.length < limit ? page : page + 1);
        }
      } else {
        setAllProducts([]);
        setTotalPages(0);
      }
    } catch (err) {
      console.error("Error loading products:", err);
      setAllProducts([]);
      setTotalPages(0);
    } finally {
      setInitialLoader(false);
      setFilterLoader(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setFilters({});
      setProducts([]);
      bodyToTop();
      await loadProducts(true);
    };
    fetchData();
  }, [slug]);

  const handlePageChange = (pageNum) => {
    loadProducts(pageNum, false);
  };

  const bodyToTop = () => {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  };

  useEffect(() => {
    const user = localStorage.getItem("customerData");
    if (user) {
      context.setState({ ...context.state, userData: JSON.parse(user) });
    }
  }, []);

  const fetchWishlistItems = async () => {
    try {
      const customerid = context.state.userData.id;
      if (customerid) {
        const res = await API.get(`v1/site/whishlist/list/${customerid}`);
        if (res.data.status === "1") {
          const ids = res.data.data.map((item) => item.id);
          setWishlistItems(ids);
        }
      }
    } catch (err) {
      console.error("Error fetching wishlist:", err);
    }
  };
  useEffect(() => {
    fetchWishlistItems();
  }, []);

  const addToCart = (id) => {
    const dat = products.find((item) => item.id === id);
    if (dat) {
      dat.quantity = 1;
      context.addToCart(dat);
      toast.success("Successfully added to cart!");
    }
  };

  const toggleWishlist = async (itemid) => {
    const customerid =
      context.state.userData.id ||
      JSON.parse(localStorage.getItem("customerData") || "{}").id;

    if (!customerid) {
      toast.error("Please login to manage your wishlist.");
      return;
    }

    const isInWishlist = wishlistItems.includes(itemid);
    const postData = new FormData();
    postData.append("customerid", customerid);
    postData.append("itemid", itemid);

    try {
      const url = isInWishlist
        ? "v1/site/whishlist/delete"
        : "v1/site/whishlist/add";
      const res = await API.post(url, postData);
      if (res.data.status === "1") {
        setWishlistItems((prev) =>
          isInWishlist ? prev.filter((id) => id !== itemid) : [...prev, itemid]
        );
        toast.success(
          isInWishlist ? "Removed from wishlist." : "Added to wishlist."
        );
      } else {
        toast.error(res.data.message || "Wishlist operation failed.");
      }
    } catch (error) {
      console.error("Wishlist error:", error);
      toast.error("Something went wrong.");
    }
  };

  return (
    <>
      <div className="tf-page-title">
        <div className="container-full">
          <div className="heading text-center">{upperCase(slug)}</div>
          <p className="text-center text-2 text_black-2 mt_5">Our Products</p>
        </div>
      </div>

      <div
        className="container-fluid my-3"
        style={{ background: "white", zIndex: "9999" }}
      >
        <div
          className="row tf-lg-hidden justify-content-center"
          style={{
            position: "fixed",
            bottom: "0px",
            background: "white",
            zIndex: "9999",
            width: "100%",
            paddingTop: "20px",
          }}
        >
          <div className="col-6">
            <div className="">
              <button
                className="btn btn-outline-dark w-100"
                onClick={() => setShowFilter(true)}
              >
                <i className="fas fa-filter me-2"></i> Filter
              </button>
            </div>
          </div>
          <div className="col-6">
            <div className="tf-control-sorting d-flex justify-content-end mb-3  scroll-3 w-100">
              <Dropdown onSelect={handleSortChange} className="">
                <Dropdown.Toggle
                  className="bg-transparent text-dark hover-0"
                  style={{ border: "1px solid #000" }}
                  id="dropdown-basic"
                >
                  Featured
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item className="text-dark" eventKey="a-z">
                    Alphabetically, A-Z
                  </Dropdown.Item>
                  <Dropdown.Item className="text-dark" eventKey="z-a">
                    Alphabetically, Z-A
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="text-dark"
                    eventKey="price-low-high"
                  >
                    Price, low to high
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="text-dark"
                    eventKey="price-high-low"
                  >
                    Price, high to low
                  </Dropdown.Item>
                  <Dropdown.Item className="text-dark" eventKey="date-old-new">
                    Date, old to new
                  </Dropdown.Item>
                  <Dropdown.Item className="text-dark" eventKey="date-new-old">
                    Date, new to old
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid my-3">
        <Row className="gutters-3">
          <Col md={3} className="scroll-1">
            <div className="tf-md-hidden">
              <FilterSidebar
                slug={slug}
                onFilterChange={handleFilterChange}
                setAllProducts={setAllProducts}
                filterCounts={filterCounts}
              />
            </div>
          </Col>

          <Col md={9} className="col-md-9  scroll-2">
            <div className="tf-control-sorting d-flex justify-content-end mb-3  scroll-3 ">
              <Dropdown onSelect={handleSortChange} className="tf-md-hidden">
                <Dropdown.Toggle
                  className="bg-transparent text-dark hover-0"
                  style={{ border: "1px solid #000" }}
                  id="dropdown-basic"
                >
                  Featured
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item className="text-dark" eventKey="a-z">
                    Alphabetically, A-Z
                  </Dropdown.Item>
                  <Dropdown.Item className="text-dark" eventKey="z-a">
                    Alphabetically, Z-A
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="text-dark"
                    eventKey="price-low-high"
                  >
                    Price, low to high
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="text-dark"
                    eventKey="price-high-low"
                  >
                    Price, high to low
                  </Dropdown.Item>
                  <Dropdown.Item className="text-dark" eventKey="date-old-new">
                    Date, old to new
                  </Dropdown.Item>
                  <Dropdown.Item className="text-dark" eventKey="date-new-old">
                    Date, new to old
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            {initialLoader && <ProductLoader size={8} />}
            {filterLoader && (
              <div className="text-center my-4">
                <Spinner animation="border" size="sm" />
                <span className="ml-2"></span>
              </div>
            )}

            <Row>
              {!initialLoader &&
                !filterLoader &&
                products.map((item) => (
                  <Col
                    xs={6}
                    sm={6}
                    md={3}
                    key={item.id}
                    className="card-product mb-3"
                  >
                    <FeaturedProduct
                      title={item.itemname}
                      image={item.image}
                      image1={item.image1}
                      id={item.id}
                      height="320px"
                      item={item}
                      amount={
                        item.salesdiscount > 0
                          ? item.discount_sales_rate
                          : item.salesrate
                      }
                      addToCart={() => addToCart(item.id)}
                      addToWishlist={() => toggleWishlist(item.id)}
                      isInWishlist={wishlistItems.includes(item.id)}
                    />
                  </Col>
                ))}
            </Row>
            {/*   {totalPages > 1 && (
              <div className="text-center my-3">
                {[...Array(totalPages)].map((_, idx) => (
                  <button
                    key={idx}
                    className={`mx-1 shadow ${
                      currentPage === idx + 1
                        ? "btn-darks"
                        : "btn-outline-darks"
                    }`}
                    style={{
                      backgroundColor: "#eee",
                      borderRadius: "5px",
                      padding: "7px 18px",
                      border: "none",
                    }}
                    onClick={() => handlePageChange(idx + 1)}
                  >
                    {idx + 1}
                  </button>
                ))}
              </div>
            )} */}

            {totalPages > 1 && (
              <div className="text-center my-3">
                {(() => {
                  const visiblePages = 5;
                  let startPage = Math.max(
                    currentPage - Math.floor(visiblePages / 2),
                    1
                  );
                  let endPage = startPage + visiblePages - 1;

                  if (endPage >= totalPages) {
                    endPage = totalPages;
                    startPage = Math.max(totalPages - visiblePages + 1, 1);
                  }

                  const pagesToShow = [];
                  for (let i = startPage; i <= endPage; i++) {
                    pagesToShow.push(i);
                  }

                  return (
                    <>
                      {startPage > 1 && (
                        <>
                          <button
                            className={`mx-1 shadow ${
                              currentPage === 1
                                ? "btn-darks"
                                : "btn-outline-darks"
                            }`}
                            onClick={() => handlePageChange(1)}
                            style={{
                              backgroundColor: "#eee",
                              borderRadius: "5px",
                              padding: "7px 18px",
                              border: "none",
                            }}
                          >
                            1
                          </button>
                          {startPage > 2 && <span className="mx-1">...</span>}
                        </>
                      )}

                      {pagesToShow.map((page) => (
                        <button
                          key={page}
                          className={`mx-1 shadow ${
                            currentPage === page
                              ? "btn-darks"
                              : "btn-outline-darks"
                          }`}
                          onClick={() => handlePageChange(page)}
                          style={{
                            backgroundColor: "#eee",
                            borderRadius: "5px",
                            padding: "7px 18px",
                            border: "none",
                          }}
                        >
                          {page}
                        </button>
                      ))}

                      {endPage < totalPages && (
                        <>
                          {endPage < totalPages - 1 && (
                            <span className="mx-1">...</span>
                          )}
                          <button
                            className={`mx-1 shadow ${
                              currentPage === totalPages
                                ? "btn-darks"
                                : "btn-outline-darks"
                            }`}
                            onClick={() => handlePageChange(totalPages)}
                            style={{
                              backgroundColor: "#eee",
                              borderRadius: "5px",
                              padding: "7px 18px",
                              border: "none",
                            }}
                          >
                            {totalPages}
                          </button>
                        </>
                      )}
                    </>
                  );
                })()}
              </div>
            )}
          </Col>
        </Row>

        <div className={`mobile-drawer ${showFilter ? "open" : ""}`}>
          <div
            className="mobile-drawer-overlay tf-lg-hidden"
            onClick={() => setShowFilter(false)}
          ></div>
          <div className="mobile-drawer-sidebar">
            <div className="text-end p-2 mb-30">
              <button
                className="btn-close bg-transparent5 border-0 w-100"
                onClick={() => setShowFilter(false)}
                style={{
                  background: "white",
                  position: "absolute",
                  right: "-110px",
                }}
              >
                <span className="icon-close"></span>
              </button>
            </div>
            <FilterSidebar
              slug={slug}
              onFilterChange={handleFilterChange}
              setAllProducts={setAllProducts}
              allProducts={allProducts}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(NewCategoryView);
